import * as React from 'react'
import { Route, Routes } from 'react-router-dom'
import { OpportunityPage } from './OpportunityPage'
import { ProtectedRouteWithToast } from '../Routes'
import { useCheckPermissions } from '@user/store/authorization/permissions'
import { AddOpportunityPage } from './AddOpportunity/AddOpportunityPage'
import { ENTITY_TYPES } from '@sales-center/common'
import { EntityDetails } from '@user/features/EntityDetails/EntityDetails'

export function OpportunityRoutes() {
  const [
    canConvertLeads,
    canCreateOpp,
    canViewOpps,
    canUpdateOpps,
    canDeleteOpps,
  ] = useCheckPermissions(
    'opportunities_convert_/_save_for_later',
    'opportunities_create',
    'opportunities_view',
    'opportunities_update',
    'opportunities_delete',
  )

  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRouteWithToast isAllowed={canViewOpps}>
            <OpportunityPage
              canDeleteOpps={canDeleteOpps}
              canUpdateOpps={canUpdateOpps}
            />
          </ProtectedRouteWithToast>
        }
      />
      <Route
        path="/addOpportunity"
        element={
          <ProtectedRouteWithToast isAllowed={canCreateOpp || canConvertLeads}>
            <AddOpportunityPage />
          </ProtectedRouteWithToast>
        }
      />
      <Route
        path="/:id"
        element={
          <ProtectedRouteWithToast isAllowed={canViewOpps}>
            <EntityDetails
              canConvertEntity={false}
              canDeleteEntity={canDeleteOpps}
              canUpdateEntity={canUpdateOpps}
              entityType={ENTITY_TYPES.Opportunity}
            />
          </ProtectedRouteWithToast>
        }
      />
    </Routes>
  )
}
